import React from 'react';
import classNames from 'classnames';
import { Icons, PrimaryButton } from '../../../components';
import { isArrayLength } from '../../../util/genericHelpers';
import { FormattedMessage } from 'react-intl';
import css from './Sections.module.css';
import { getTalentServiceDescription } from '../../../config/configExtras';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../util/routes';
import { SignatureServiceTypes } from '../../../util/enums';

function SectionAppearances({
  selectedSignatureService,
  providerServices,
  title,
  talentRate,
  listing,
}) {
  // Ensure that we filter only selected appearances
  const appearances =
    (isArrayLength(providerServices) && providerServices.filter(s => s?.selected)) || [];

  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const listingId = listing?.id?.uuid;

  const navigateToServiceOfferingsPage = item => {
    const pathname = createResourceLocatorString(
      'ServiceOfferingsPage',
      routeConfiguration,
      { id: listingId, type: SignatureServiceTypes.APPEARANCES },
      {}
    );

    history.push({
      pathname,
      state: { item }, // <-- send item in state
    });
  };
  return (
    <>
      <div className={css.getCustomVideo}>
        <h2>
          {selectedSignatureService?.title}{' '}
          <FormattedMessage id="SectionAppearances.from" values={{ title }} />
        </h2>
      </div>

      {isArrayLength(appearances) ? (
        appearances.map((appearance, index) => (
          <div key={index} className={css.bookingSec}>
            <div className={classNames(css.offerSec, css.withoutIconSec)}>
              <div className={css.offerContent}>
                <h2>{appearance?.title}</h2>

                {/* Display talent's rate per hour if applicable */}
                {talentRate && (
                  <p className={css.rateTag}>
                    <FormattedMessage id="SectionAppearances.rate" values={{ rate: talentRate }} />
                  </p>
                )}

                <p>{getTalentServiceDescription(appearance?.title)}</p>

                {/* Display price if it exists, otherwise fallback to talent's rate */}
                <p className={css.priceTag}>
                  <FormattedMessage
                    id="SectionAppearances.price"
                    values={{ price: appearance?.price || talentRate }}
                  />
                </p>

                <PrimaryButton
                  className={css.bookBtn}
                  type="button"
                  onClick={() => navigateToServiceOfferingsPage(appearance)}
                >
                  <Icons name="security" />
                  <FormattedMessage id="SectionAppearances.buyNow" />
                </PrimaryButton>
              </div>
            </div>
          </div>
        ))
      ) : (
        <p className={css.noServices}>
          <FormattedMessage id="SectionAppearances.noAppearances" />
        </p>
      )}
    </>
  );
}

export default SectionAppearances;
